import React from "react";
import Box from '@mui/material/Box';
import './home.css';

const HomeRepl_B = (props) => {
    const imgpath = props.imgaddress;
    
    const path = 'url(' + imgpath + ')';
    const myStyle={
        backgroundImage: path,
        height:'100vh',
        justifyContent:'center',
        width:'90vw',
        marginTop:'-70px',
        fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
};
    return (
        <> 
        
        <Box className="l1__boxB" sx={{marginTop:'-1.4%',backgroundColor:'#202020',width:'100vw',maxWidth:'100%',height:'100vh',maxheight:'100%'}}>
        <div className="homeleft_B">
            <p>{props.subhead}</p>
            <div className="homeleft__img_B">
            <img id='homeleft_B' src={imgpath} alt="" />
            </div>
        </div>
        </Box>
          
        {/* </div> */}
        
        <div style={{marginleft:'15%'}} className="split-box1">
        <Box 
            sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh',maxHeight:'100%',maxWidth:'100%',backgroundColor:'#202020'},           
            [theme.breakpoints.up('md')]:{ width: '50vw',height:'100vh',maxHeight:'50%',maxWidth:'50%',backgroundColor:'#202020'}
            })}
        
        
        >
        <div className="small_homeleft_img_B">
           <img id='small_homeleft_B' src={imgpath} alt="error" />
           </div>
        </Box>


        <Box 
             sx={theme => ({ [theme.breakpoints.between(0,600)]:{width: '100vw',height:'50vh',maxHeight:'100%',maxWidth:'100%',backgroundColor:'white'},           
             [theme.breakpoints.up('md')]:{ width: '50vw',height:'100vh',maxHeight:'50%',maxWidth:'50%',backgroundColor:'white'}
             })}>
        <div className="homerepl__theory">
             <p>{props.subhead}</p>
             <div>{props.subinfo}</div>
        </div>
        </Box>
        </div>
        </>
 );
}
export default HomeRepl_B;